export default __webpack_public_path__ + "static/media/Daly_College_Indore.5c88de57.jpg";